'use client';

import { useAuthStore } from '../stores/authStore';

export function useIsAuthed(): boolean {
  return useAuthStore((s) => s.isAuthenticated);
}
